import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { threadUsersBackend } from './thread-users.backend';
import { threadUsersReducer } from './thread-users.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('threadUsers', threadUsersReducer),
    BackendModule.forFeature('threadUsers', threadUsersBackend),
  ],
})
export class DatastoreThreadUsersModule {}
